import React from 'react';
import {
  toNumber,
  zeroPad,
} from '../../../utils/numbers';
import { AnalogIconList } from '../../../constants/DeviceModels';

export function DeviceStatusLabel(props) {
  return (
    <div className={`device-label device-label-status ${props.isHorizontal ? 'device-label--horizontal' : ''} ${props.className || ''}`}>
      <div className="device-type" title={props.title}>
        {props.displayIcon ? <i className="fa fa-warning"/> : ''} {' '}
        {props.interlockIcon === true ? <i className="fa scale-interlock-on fa-lock" title="interlock"/> : ''} {' '}
        {props.interlockIcon === false ? <i className="fa scale-interlock-off fa-lock-open" title="interlock"/> : ''} {' '}
        {props.name}
      </div>
      {props.description &&
        <div className="device-description">{props.description}</div>
      }
      <div className="status">{props.status}</div>
    </div>
  );
}

export function FlowRateLabel(props) {
  const padZeros = props.padZeros;
  const flowrate = padZeros ? zeroPad(props.flowrate, 2) : props.flowrate;

  return (
    <div className="flow-rate">
      <i className="fa fa-bars"/>
      <span>{flowrate} {props.unit}/s</span>
    </div>
  );
}

export function FlowRateTargetLabel(props) {
  const padZeros = props.padZeros;
  const target = padZeros ? zeroPad(props.target, 2) : props.target;

  return (
    <div className="flow-rate-target">
      <i className="fa fa-crosshairs"/>
      <span>{target} {props.unit}/s</span>
    </div>
  );
}

export function InventoryLabel(props) {
  return (
    <div className="device-icon label-inventory">
      <i className="fa fa-cube"/>
      <span>{toNumber(props.balance, props.decimal || (props.balance < 1 && props.balance > 0  ? 2 : 0))} {props.unit || ''}</span>
    </div>
  );
}

export function CapacityLabel(props) {
  return (
    <div className="device-icon label-capacity">
      <i className="fa fa-database"/>
      <span>{toNumber(props.capacity, props.decimal || (props.capacity < 1 && props.capacity > 0  ? 2 : 0))} {props.unit || ''}</span>
    </div>
  );
}

export function IconUnitLabel(props) {
  let icon = '';
  switch (props.icon) {
    case AnalogIconList.BOLT:
      icon = 'fa-bolt';
      break;
    case AnalogIconList.DROP:
      icon = 'fa-tint';
      break;
    case AnalogIconList.EXCLAMATION:
      icon = 'fa-exclamation';
      break;
    case AnalogIconList.PLUG:
      icon = 'fa-plug';
      break;
    case AnalogIconList.SPEAKER:
      icon = 'fa-volume-down';
      break;
    default:
      icon = '';
  }

  return (
    <div className="device-icon label-moisture">
      {icon ? <i className={`fa ${icon}`}/> : ''}
      <span>{props.value} {props.unit || ''}</span>
    </div>
  );
}

export function BalanceLabel(props) {
  const padZeros = props.padZeros;
  const balance = padZeros ? zeroPad(props.balance, 2) : props.balance;
  const convertedBalance = padZeros ? zeroPad(props.convertedBalance, 2) : props.convertedBalance;

  return (
    <div className="balance">
      <i className="fa fa-tint"/>
      <span>
        {!!convertedBalance && !!props.convertedUnit && (props.unit !== props.convertedUnit) &&
        <span>{convertedBalance} {props.convertedUnit}<br/></span>
        }
        {balance} {props.unit}
      </span>
    </div>
  );
}

export function TargetLabel(props) {
  const icon = props.icon ? props.icon : 'fa fa-crosshairs';
  const targetValue = props.target;
  const padZeros = props.padZeros;

  return (
    <div className="target">
      <i className={icon}/>
      <span>
        {!!props.convertedTarget && !!props.convertedUnit && (props.unit !== props.convertedUnit) &&
        <span>{props.convertedTarget} {props.convertedUnit}<br/></span>
        }
        {padZeros ? zeroPad(targetValue, 2) : targetValue} {props.unit}
      </span>
    </div>
  );
}
